import React from "react";
import { Navigate, generatePath, useParams } from "react-router-dom";

function HamperDetails() {
  const { ThemeName, HamperName } = useParams();

  const mapLegacyDetails = (themeName, hamperName) => {
    if (!themeName || !hamperName) return null;

    if (
      themeName.toLowerCase() === "wedding" &&
      hamperName.toLowerCase() === "stag"
    ) {
      return {
        occasionName: "weddings-anniversaries",
        hamperName: "groom-hamper",
      };
    }

    return {
      occasionName: themeName,
      hamperName: hamperName.toLowerCase() === "home" ? "New-Home" : hamperName,
    };
  };

  if (!ThemeName || !HamperName) {
    return <Navigate to="/Occasions" replace />;
  }

  const mappedTarget = mapLegacyDetails(ThemeName, HamperName);

  return (
    <Navigate
      to={generatePath("/Occasions/:OccasionName/:HamperName", {
        OccasionName: mappedTarget.occasionName,
        HamperName: mappedTarget.hamperName,
      })}
      replace
    />
  );
}

export default HamperDetails;